import React, { useEffect, useMemo } from 'react';
import { UiText, UiGrid, UiFlex, UiButton } from '@open-stack/ui';
import { useCurrency } from '../../../../hooks/currency';
import { useOrderProductOverlay } from '../../../../hooks/order-product-overlay';
import styled from 'styled-components';
import clsx from 'clsx';
import { Product } from '../../../../XV2';
import { MenuProduct } from '../../../../XV2';
import { useActiveOrder } from '../../../../hooks/active-order';
import { useActiveOrderManager } from '../../../../hooks/useActiveOrderManager';

const Wrapper = styled(UiFlex)`
    border-radius: var(--XCard-border-radius);
    padding: var(--ui-spacing);
    justify-content: space-between;
    background-color: var(--color-layer);

    &.animate {
        animation: animateSuccessToTransparent 0.5s;
    }
`;

interface Props {
    position: number;
    menuProduct: MenuProduct;
    orderProductId: number;
    product: Product;
}

export function MenuProductCardOrderProduct({ position, menuProduct, orderProductId, product }: Props) {
    const { getCountByProductId, getOrderProductById, animatedIds, addAnimatedId } = useActiveOrder();
    const activeOrderManager = useActiveOrderManager();
    const { setProduct } = useOrderProductOverlay();
    const productCount = getCountByProductId(product.id);
    const isMultiple = productCount > 1 || true;
    const { format } = useCurrency();
    const animate = useMemo(() => !animatedIds.includes(orderProductId), []);
    const orderProduct = getOrderProductById(orderProductId);

    useEffect(() => {
        if (orderProductId && !animatedIds.includes(orderProductId)) {
            addAnimatedId(orderProductId);
        }
    }, [animatedIds, orderProductId]);

    if (!isMultiple) {
        return null;
    }

    return (
        <Wrapper onClick={() => setProduct(menuProduct, orderProductId)} className={clsx({ animate })}>
            <UiGrid gap={0}>
                <UiText>
                    #{position} {product.name}
                </UiText>

                <UiText color="text-secondary">
                    {format(activeOrderManager.calculateActiveOrderProductPrice(orderProduct))}
                </UiText>
            </UiGrid>

            <UiButton icon="edit" variant="text" />
        </Wrapper>
    );
}
